var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"user_wrap"},[_c('keep-alive',{attrs:{"include":"info"}},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }